export default "__VITE_ASSET__19f6dbc2__"